import { useContext } from 'react';
import EditGymSettings from './EditGymSettings/EditGymSettings';
import EditAssociatedNames from './AddEditAssociatedNames/EditAssociatedNames';
import { ALL_CLASS_TYPES_DETAILS } from '../../constants';
import ClassConfig from './ClassConfig/ClassConfig';
import useTabIndex from '../../hooks/useTabIndex';
import { AppContext } from '../../context/App/AppContext';
import Title from '../../components/UI/Title/Title';
import { Tabs } from 'antd';
import AddEditGym from './AddEditGym/AddEditGym';
import { useMutation } from '@tanstack/react-query';
import { returnErrorFromResponse } from '../../shared/utility';
import { NotificationContext } from '../../context/Notification/NotificationContext';
import { editGymSettings, refreshFetchFunctions } from '../../apiFunctions/apiFunctions';

const ManageGym = () => {
  const { openNotification } = useContext(NotificationContext);
  const { selectedGym, timetableDisplaySettings } = useContext(AppContext);
  const { activeTabIndex, secondActiveTabIndex, onTabChange } = useTabIndex();

  const { mutate: onSaveGymSettings, isLoading: onSaveGymSettingsIsLoading } = useMutation({
    mutationFn: (data) => editGymSettings(selectedGym.settings._id, { ...selectedGym.settings, ...data }),
    onSuccess: () => {
      openNotification('save', 'success');
      refreshFetchFunctions([['selectedGym', selectedGym._id]]);
    },
    onError: (data) => {
      openNotification(null, 'error', returnErrorFromResponse(data));
    }
  });

  const items = [
    {
      key: '0',
      label: 'Basic information',
      children: <AddEditGym isAddNewGym={false} />
    },
    {
      key: '1',
      label: 'Associated names',
      children: <EditAssociatedNames />
    },
    {
      key: '2',
      label: 'Gym properties',
      children: (
        <EditGymSettings
          selectedGym={selectedGym}
          onSave={onSaveGymSettings}
          onSaveIsLoading={onSaveGymSettingsIsLoading}
        />
      )
    },
    {
      key: '3',
      label: 'Gym assortment',
      children: (
        <Tabs
          activeKey={secondActiveTabIndex.toString()}
          onChange={(key) => onTabChange(activeTabIndex, Number(key))}
          tabPosition={'left'}
          items={ALL_CLASS_TYPES_DETAILS.map((classType, i) => ({
            key: i.toString(),
            label: classType.title,
            children: (
              <ClassConfig
                classType={classType}
                selectedGym={selectedGym}
                timetableDisplaySettings={timetableDisplaySettings}
                onSave={onSaveGymSettings}
                onSaveIsLoading={onSaveGymSettingsIsLoading}
              />
            )
          }))}
        />
      )
    }
  ];

  return (
    <div>
      <Title title={'Gym settings'} />
      <Tabs
        activeKey={activeTabIndex.toString()}
        onChange={(key) => onTabChange(Number(key))}
        items={items}
        data-cy="tabList"
      />
    </div>
  );
};
export default ManageGym;
